module.exports = __webpack_public_path__ + "img/visa-2014.862bf86b.svg";